
import { clone } from "@/modules/Etiquetas/services/etiquetaDefinition";

export default {
  name: "EtiquetaElementInspector",
  props: {
    element: { type: Object, default: null },
    label: { type: Object, default: () => ({}) },
    fields: { type: Array, default: () => [] },
    fonts: { type: Array, default: () => [] },
    barcodeTypes: { type: Array, default: () => [] },
    displayRules: { type: Array, default: () => [] },
  },
  computed: {
    isSalePrice() {
      return (
        this.element?.tipo === "field" &&
        this.element?.campo === "produto.preco"
      );
    },
    priceModeHasInstallments() {
      return ["installment", "cash_installment"].includes(
        this.get("priceMode", "cash")
      );
    },
    hasField() {
      return (
        this.element &&
        ["field", "barcode", "qrcode"].includes(this.element.tipo)
      );
    },
    hasTextFormat() {
      return this.element && ["field", "text"].includes(this.element.tipo);
    },
    hasAppearance() {
      return (
        this.element &&
        !["qrcode", "logo", "line", "rectangle"].includes(this.element.tipo)
      );
    },
    hasContentAlignment() {
      return this.element && ["field", "text"].includes(this.element.tipo);
    },
    fieldGroups() {
      const groups = this.fields.reduce((result, field) => {
        const name = field.category || "Outros";
        if (!result[name]) result[name] = [];
        result[name].push(field);
        return result;
      }, {});
      return Object.keys(groups).map((name) => ({
        name,
        fields: groups[name],
      }));
    },
  },
  methods: {
    setField(field) {
      const next = clone(this.element);
      next.campo = field;
      if (
        next.tipo === "field" &&
        field === "produto.preco" &&
        !next.priceMode
      ) {
        next.priceMode = "cash";
        next.installments = 3;
        next.installmentIncrease = 0;
        next.commercialEnding = "none";
      }
      this.$emit("change-start");
      this.$emit("update", next);
    },
    setPriceMode(mode) {
      const next = clone(this.element);
      next.priceMode = mode;
      if (next.installments === undefined) next.installments = 3;
      if (next.installmentIncrease === undefined) next.installmentIncrease = 0;
      if (next.commercialEnding === undefined) next.commercialEnding = "none";
      if (mode === "cash_installment") {
        const style = next.estilo || {};
        const lineHeight = Number(style.tamanho_pt || 8) * 0.3528 * 1.05;
        const minimum =
          2 * lineHeight +
          2 * Number(style.padding_mm || 0) +
          2 * Number(style.borda_mm || 0) +
          1;
        const labelHeight = Number(this.label.altura_mm || 0);
        if (!labelHeight || Number(next.y_mm || 0) + minimum <= labelHeight) {
          next.altura_mm = Math.max(
            Number(next.altura_mm || 0),
            Math.ceil(minimum * 10) / 10
          );
        }
      }
      this.$emit("change-start");
      this.$emit("update", next);
    },
    get(path, fallback) {
      const value = path
        .split(".")
        .reduce(
          (current, part) => (current ? current[part] : undefined),
          this.element
        );
      return value === undefined || value === null ? fallback : value;
    },
    set(path, value) {
      const next = clone(this.element);
      const parts = path.split(".");
      const last = parts.pop();
      let current = next;
      parts.forEach((part) => {
        if (!current[part]) this.$set(current, part, {});
        current = current[part];
      });
      current[last] = value;
      this.$emit("change-start");
      this.$emit("update", next);
    },
    setNumber(path, value) {
      const number = Number(value);
      if (!Number.isNaN(number)) this.set(path, number);
    },
    toggle(path) {
      this.set(path, !this.get(path, false));
    },
    toggleTransparent() {
      this.set(
        "estilo.fundo",
        this.get("estilo.fundo", "transparent") === "transparent"
          ? "#FFFFFF"
          : "transparent"
      );
    },
    colorValue(value) {
      return /^#[0-9a-f]{6}$/i.test(String(value || "")) ? value : "#FFFFFF";
    },
  },
};
